var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.psdLayers
    ? _c(
        "div",
        [
          _c("div", { staticClass: "row align-center" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _setup.psdLayers.type == "PSD"
                  ? _c(
                      "div",
                      [
                        _c("h6", {
                          staticClass: "font-weight-bold no-wrap align-center",
                          domProps: { textContent: _vm._s("PSD") },
                        }),
                        _vm._v(" "),
                        _c(_setup.ModalImportListItem, {
                          attrs: {
                            item: _setup.psdHeader,
                            "prevent-action": true,
                          },
                        }),
                      ],
                      1
                    )
                  : [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-column" },
                        [
                          _c("h6", {
                            staticClass:
                              "font-weight-bold no-wrap align-center",
                            domProps: { textContent: _vm._s("Design") },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "list-group-item d-inline-flex border-0 px-0 disabled",
                            },
                            [
                              _setup.psdHeader.thumb
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "mr-2",
                                      staticStyle: {
                                        height: "97px",
                                        width: "136px",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticClass:
                                          "img-thumbnail p-0 img-fluid h-100 w-100",
                                        attrs: {
                                          src: _setup.getThumbUrl(
                                            _setup.psdHeader.thumb
                                          ),
                                          alt: "",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_setup.psdHeader.name)),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mt-3 mb-3" },
                            [
                              _vm._m(0),
                              _vm._v(" "),
                              _c(_setup.CButtonGroup, {
                                attrs: {
                                  value: _setup.psdHeader.mode,
                                  type: "radio",
                                  items: _setup.importModes,
                                  "no-icon": "",
                                },
                                on: { input: _setup.onImportModeChange },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(_setup.CSelect, {
                            staticClass: "flex-fill w-50",
                            attrs: {
                              value: _setup.selectedOption,
                              options: _setup.pages,
                              label: "Select one page to import",
                              "label-class": "text-bold mb-2",
                            },
                            on: { input: _setup.onPageChange },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "selected-option",
                                  fn: function ({ thumb, label }) {
                                    return [
                                      _c(_setup.PageFileOption, {
                                        attrs: { thumb: thumb, label: label },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: "option",
                                  fn: function ({ thumb, label }) {
                                    return [
                                      _c(_setup.PageFileOption, {
                                        attrs: { thumb: thumb, label: label },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              928215949
                            ),
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "mt-3" }, [
                            _vm._v("Import design dimensions"),
                          ]),
                          _vm._v(" "),
                          _c("b-form-checkbox", {
                            attrs: { name: "check-button", switch: "" },
                            model: {
                              value: _setup.importPageDimensions,
                              callback: function ($$v) {
                                _setup.importPageDimensions = $$v
                              },
                              expression: "importPageDimensions",
                            },
                          }),
                          _vm._v(" "),
                          _setup.psdHeader.mode == "PNG"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "h6",
                                    {
                                      staticClass:
                                        "font-weight-bold no-wrap align-center mt-3",
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Do you want to import with a transparent background?\n                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center png-transparency-disclaimer mb-3",
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "mr-2",
                                        attrs: { icon: ["fas", "circle-info"] },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "notification-message mb-1 mr-2",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                To import with a transparent background you must have Canva Pro. If you don't have\n                                it, it will still be imported with a background.\n                            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    _setup.LoaderBtn,
                                    {
                                      attrs: {
                                        variant: "primary",
                                        "loading-text": "Importing...",
                                        loading: _setup.importingPngTransparent,
                                        disabled: _setup.showLoader,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _setup.importAsPngLayer(true)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Make it transparent\n                        "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    _setup.LoaderBtn,
                                    {
                                      staticClass: "ml-2",
                                      attrs: {
                                        variant: "outline-primary",
                                        "loading-text": "Importing...",
                                        loading:
                                          _setup.importingPngNonTransparent,
                                        disabled: _setup.showLoader,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _setup.importAsPngLayer()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Import with background\n                        "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _setup.psdHeader.mode == "LAYERS"
            ? [
                _c("div", { staticClass: "row mt-4 align-center" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-sm-5" },
                    [
                      _c(_setup.ModalImportSearch, {
                        on: { "search-text-change": _setup.updateSearchText },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mt-2 mb-2" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 layer-tree" },
                    [
                      _setup.showLoader
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "align-items-center d-flex justify-content-center my-2 text-center my-2",
                            },
                            [
                              _c("b-spinner", {
                                attrs: { variant: "primary" },
                              }),
                              _vm._v(" "),
                              _c(
                                "strong",
                                { staticClass: "ml-3 primary-text" },
                                [_vm._v(_vm._s(_setup.loaderMessage))]
                              ),
                            ],
                            1
                          )
                        : [
                            _c(_setup.ModalImportLayersTree, {
                              attrs: { "tree-item": _setup.filteredTreeItems },
                            }),
                            _vm._v(" "),
                            _c("b-pagination", {
                              staticClass: "mt-4",
                              attrs: {
                                "total-rows": _setup.pageElementsCount,
                                "per-page": _setup.perPage,
                                "aria-controls": "my-table",
                                align: "center",
                              },
                              model: {
                                value: _setup.currentPage,
                                callback: function ($$v) {
                                  _setup.currentPage = $$v
                                },
                                expression: "currentPage",
                              },
                            }),
                          ],
                    ],
                    2
                  ),
                ]),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "mb-1" }, [_c("span", [_vm._v("Import")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-12 col-sm-7" }, [
      _c("h6", { staticClass: "font-weight-bold no-wrap align-center" }, [
        _vm._v("Select the layers to import"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }